var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _vm.title
      ? _c("div", { staticClass: "mb-40 d-flex flex-wrap w-100" }, [
          _c("h3", {
            staticClass: "title",
            domProps: { innerHTML: _vm._s(_vm.title) }
          }),
          _vm._v(" "),
          _vm.generatedCtaLink
            ? _c(
                "a",
                {
                  staticClass: "ml-auto my-auto link-arrow",
                  attrs: { href: _vm.generatedCtaLink }
                },
                [
                  _vm._v(_vm._s(_vm.cta) + " "),
                  _c("span", {
                    staticClass: "arrow-right",
                    domProps: { innerHTML: _vm._s(_vm.svg("arrow-right")) }
                  })
                ]
              )
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.location
      ? _c(
          "a",
          {
            staticClass: "position-relative",
            attrs: {
              href: _vm.route(
                "nl.location",
                _vm.location.slug != null
                  ? { slug: _vm.location.slug }
                  : { slug: _vm.location.post_name }
              )
            }
          },
          [
            _c("div", { staticClass: "mx-n24 mx-md-0" }, [
              _c("div", { staticClass: "location-banner" }, [
                _vm.location.acf && _vm.location.acf.image
                  ? _c("img", {
                      attrs: {
                        src: _vm.location.acf.image.url,
                        alt: _vm.location.post_name
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "content" }, [
                  _vm.location.post_name
                    ? _c("h2", { staticClass: "mb-8 text-white title" }, [
                        _vm._v(
                          _vm._s(
                            _vm.location.post_title
                              ? _vm.location.post_title
                              : _vm.location.title.rendered
                          )
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.location.acf && _vm.location.acf.highlighted_title
                    ? _c(
                        "p",
                        {
                          staticClass:
                            "text-white font-weight-light description"
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.location.acf.highlighted_title) +
                              "\n                    "
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ])
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }